import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@utils/constant";

const ReassignDriverStyle = makeStyles({
  customForm: {
    overflow: "hidden",
    "& .form-row": {
      display: "flex",
      margin: "0 -10px",
      "@media (max-width: 575px)": {
        flexWrap: "wrap",
      },
      "& .form-group": {
        padding: "0 10px",
        maxWidth: "100%",
        flex: "0 0 100%",
        minWidth: "350px",
        "@media (max-width: 575px)": {
          minWidth: "100%",
        },
        "& .MuiFormControl-root:not(:last-child)": {
          marginBottom: "15px",
        },
        "& .label-text": {
          fontSize: "14px",
        },
        "& .error-text": {
          color: "red",
        },
        "& .linkButton": {
          width: "100%",
          height: "50px",
          lineHeight: "50px",
          textTransform: "uppercase",
          color: colors.primary,
          backgroundColor: "rgba(0, 84, 142, 0.08)",
          boxShadow: "none",
        },
      },
    },
  },
  customModal: {
    "& .MuiDialog-paperWidthSm": {
      boxShadow: "0 5px 8px 0 rgba(0, 0, 0, 0.24)",
      padding: "36px 40px 36px",
      maxWidth: "500px",
      width: "100%",
      "@media (max-width: 991px)": {
        margin: "30px 15px",
        maxWidth: "500px",
        width: "100%",
      },
      "@media (max-width: 767px)": {
        maxWidth: "calc(100% - 64px)",
        margin: "30px 15px",
        verticalAlign: "baseline",
      },
      "& .MuiDialogTitle-root": {
        padding: "0",
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "30px",
        "@media (max-width: 480px)": {
          marginBottom: "20px",
        },
      },
      "& .MuiDialogContent-root": {
        padding: "0",
        overflow: "hidden",
      },
      "& h2": {
        fontSize: "24px",
        fontWeight: "700",
        lineHeight: "40px",
      },
    },
    "& .close-modal": {
      position: "absolute",
      right: "15px",
      top: "15px",
      cursor: "pointer",
      "@media (max-width: 991px)": {
        top: "28px",
        right: "25px",
      },
    },
    "& .MuiFormControl-root": {
      "& > div": {
        "&::after": {
          display: "none",
        },
      },
    },
    "& .MuiInputBase-root.MuiInput-root": {
      border: "none",
      "& input": {
        border: "none",
      },
    },
    "& .MuiFormControl-marginNormal": {
      margin: "0",
    },
    "& .bottom-button-block": {
      paddingTop: 25,
      display: "flex",
      justifyContent: "space-between",
      "@media (max-width: 480px)": {
        flexDirection: "column",
      },
      "& button": {
        height: "50px",
        lineHeight: "50px",
        fontWeight: "600",
        fontSize: "16px",
        minWidth: "165px",
        textTransform: "uppercase",
        "& + button": {
          marginLeft: "15px",
          "@media (max-width: 480px)": {
            marginLeft: "0",
          },
        },
        "@media (max-width: 480px)": {
          minWidth: "100%",
          marginBottom: "15px",
          marginLeft: "0",
        },
        "@media (max-width: 300px)": {
          minHeight: 50,
          height: "auto",
          lineHeight: "normal",
        },
      },
    },
  },
  inputAutoComplete: {
    "& .MuiPaper-root": {
      width: "100%",
      "& .MuiAutocomplete-listbox": {
        width: "100%",
        "& li": {
          fontSize: "16px",
          padding: "10px 15px",
          "&.MuiListItem-root.Mui-focusVisible:hover": {
            backgroundColor: "rgba(247, 146, 57, 0.2)",
          },
          "&.MuiListItem-root.Mui-focusVisible": {
            backgroundColor: "transparent",
          },
          "&.Mui-disabled": {
            display: "none",
          },
          "&:hover": {
            color: colors.orange,
            backgroundColor: "rgba(247, 146, 57, 0.2)",
          },
          "&.Mui-selected, &.Mui-selected:hover": {
            backgroundColor: colors.orange + "!important",
            color: colors.white,
            fontWeight: "600",
            opacity: "1 !important",
            "&.disableHover": {
              backgroundColor: "transparent !important",
              color: "#212121 !important"
            }
          },
          "& .MuiListItemText-root .MuiTypography-body1": {
            fontSize: "16px",
            lineHeight: "1.3",
          },
        },
      },
    },
  },
});

export { ReassignDriverStyle };
